/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-CUSTOMER-API API
 * API specification for MALIYONE-CUSTOMER-API
 * OpenAPI spec version: 1.0.0
 */

export type ContactDetailCreateContactType = typeof ContactDetailCreateContactType[keyof typeof ContactDetailCreateContactType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactDetailCreateContactType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  MOBILE: 'MOBILE',
} as const;
